module.exports = __webpack_public_path__ + "assets/img/part2.14306066.png";